import axiosInstance from "../config/axios.config";

const ROLES_URL = "clinical-forms/roles/";
const FORMS_URL = "clinical-forms/forms/";
const SUBMISSIONS_URL = "clinical-forms/submissions/";

const urlencodedConfig = {
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
  transformRequest: [(data) => new URLSearchParams(data).toString()],
};

export const listClinicalRolesApi = (params) =>
  axiosInstance.get(ROLES_URL, { params });

export const createClinicalRoleApi = (payload) =>
  axiosInstance.post(ROLES_URL, payload, urlencodedConfig);

export const listClinicalFormsApi = (params) =>
  axiosInstance.get(FORMS_URL, { params });

export const listClinicalFormsForAdmissionApi = (params) =>
  axiosInstance.get(`${FORMS_URL}for-admission/`, { params });

export const getClinicalFormApi = (formId) =>
  axiosInstance.get(`${FORMS_URL}${formId}/`);

export const createClinicalFormApi = (payload) =>
  axiosInstance.post(FORMS_URL, payload, urlencodedConfig);

export const updateClinicalFormApi = (formId, payload) =>
  axiosInstance.patch(`${FORMS_URL}${formId}/`, payload, urlencodedConfig);

export const listClinicalFormSubmissionsApi = (params) =>
  axiosInstance.get(SUBMISSIONS_URL, { params });

export const getClinicalFormSubmissionApi = (submissionId) =>
  axiosInstance.get(`${SUBMISSIONS_URL}${submissionId}/`);

export const createClinicalFormSubmissionApi = (payload) =>
  axiosInstance.post(SUBMISSIONS_URL, payload, urlencodedConfig);

export const updateClinicalFormSubmissionApi = (submissionId, payload) =>
  axiosInstance.patch(
    `${SUBMISSIONS_URL}${submissionId}/`,
    payload,
    urlencodedConfig
  );
